import React, { useEffect, useState } from "react";
import ClientLayout from "./ClientLayout";
import { GetAccess } from "../../../../Components/Utils/roles";
import { Link, useLocation, useParams } from "react-router-dom";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import ViewIcon from "../../../../Components/Icons/ViewIcon";
import NuDate from "../../../../Components/Utils/NuDate";
import MobileContractIndex from "../../../Mobile/ClientManage/ClientMoblie/MobileContractIndex";
import NuAmount from "../../../../Components/Utils/NuAmount";

function Contracts() {
  const { clientViewId, contractsViewId } = useParams();
  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20
  );
  const state = location.state;

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [params, setParams] = useState({
    //  page: page,
    //  per_page: pageCount,
    //  search:searchQuery||"",

    status: "",
    rfqAssignee: "",
    salesPerson: "",
    deadLineFrom: "",
    deadLineTo: "",
    approvalStatus: state?.approvalStatus ? state.approvalStatus : "",
    category: state?.category ? state.category : "",
  });
  const { data, getData, dataLoading } = UseGetDataSearch(
    `/contract/client/${clientViewId}`,
    params
  );
  console.log(data, "contractcli");

  return (
    <ClientLayout BackAccess={GetAccess("client_management_module")}>
      {screenSize.width < "768" ? (
        <>
          <div className=" w-full h-[calc(100vh-175px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden">
            <MobileContractIndex
              data={data}
              // total={totalCount}
              pageIndex={page}
              setPageIndex={setPage}
              dataCount={pageCount}
              setDataCount={setPageCount}
              // officeId={officeId}
              getData={getData}
            />
          </div>
        </>
      ) : (
        <>
          <div className="overflow-x-auto mt-0.5 rounded-md bg-white h-[calc(100vh-160px)]">
            <table className="min-w-full text-xs text-left">
              <thead>
                <tr className="text-black font-semibold border-b border-gray-300">
                  <th className="px-4 py-2 w-[8%]">Ref.</th>
                  {/* <th className="px-4 py-2 w-[5%]">Client</th> */}
                  <th className="px-4 py-2 w-[17.4%]">Description</th>
                  <th className="px-4 py-2 w-[17.4%]">Start Date</th>
                  <th className="px-4 py-2 w-[17.4%]">End Date</th>
                  <th className="px-4 py-2 w-[17.4%]">Amount</th>
                  <th className="px-4 py-2 w-[17.4%]">Status</th>
                  <th className="px-4 py-2 w-[5%]">Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((data) => (
                  <tr
                    key={data.id}
                    className=" hover:bg-gray-50 rounded-md shadow-sm"
                  >
                    <td className="px-4 py-2 w-[8%]">
                      <Link
                        to={`/Contract-management/contracts/view/${data?.id}`}
                      >
                        {data.refNumber || "-"}
                      </Link>
                    </td>
                    <td className="px-4 pt-2 text-left  line-clamp-2 ">
                      <Link
                        to={`/Contract-management/contracts/view/${data?.id}`}
                      >
                        {data.description || "-"}
                      </Link>
                    </td>
                    {/* <td className="px-4 py-2 w-[5%]">{data.date ? (
                       <NuDate
                         value={data?.date}
                         format="DD-MMM-YYYY"
                       />
                     ) : (
                       "N/A"
                     )}</td> */}
                    <td className="px-4 py-2 w-[17.4%] ">
                      <Link
                        to={`/Contract-management/contracts/view/${data?.id}`}
                      >
                        {data.startDate ? (
                          <NuDate
                            value={data?.startDate}
                            format="DD-MMM-YYYY"
                          />
                        ) : (
                          "N/A"
                        )}
                      </Link>
                    </td>
                    <td className="px-4 py-2 w-[17.4%]">
                      {data.endDate ? (
                        <NuDate value={data?.endDate} format="DD-MMM-YYYY" />
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td className="px-4 py-2 text-left w-[17.4%]">
                      <NuAmount value={data.amount} />
                    </td>
                    <td className="px-4 py-2 w-[17.4%]">
                      {data.status || "-"}
                    </td>
                    <td className="px-4 py-2 text-gray-500 w-[5%]">
                      <Link
                        to={`/Contract-management/contracts/view/${data?.id}`}
                        state={{
                          data: data,
                          from: `/client-management/clients/contracts/${clientViewId}`,
                        }}
                      >
                        <ViewIcon color="#048178" />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </ClientLayout>
  );
}

export default Contracts;
